import { useClickOutside } from '@portalterreno/react-ui-core/hooks';
import React, { useState } from 'react';

export type WithDropdownHandlerProps = {
  handleOpenList: () => void;
  isShareListOpen: boolean;
  wrapperRef: React.RefObject<HTMLDivElement>;
};

const withDropdownHandler = (
  ShareButton: React.FC<WithDropdownHandlerProps>
) => {
  return function Component({ ...rest }) {
    const wrapperRef = React.useRef<HTMLDivElement>(null);

    const [isShareListOpen, setIsShareListOpen] = useState<boolean>(false);

    useClickOutside(
      wrapperRef,
      React.useCallback(() => {
        setIsShareListOpen(false);
      }, [])
    );

    const handleOpenList = React.useCallback(() => {
      setIsShareListOpen((previousState) => !previousState);
    }, []);

    return (
      <ShareButton
        wrapperRef={wrapperRef}
        isShareListOpen={isShareListOpen}
        handleOpenList={handleOpenList}
        {...rest}
      />
    );
  };
};

export default withDropdownHandler;
